import request, { type ApiResponse, type RequestConfig } from "@/utils/request";
import type { IApprovalGroup, ITaskCount } from "@/types/approvals";

// 获取审批列表
export const getApprovalsList = (params: any, config?: RequestConfig): Promise<ApiResponse<IApprovalGroup[]>> => {
  return request.post("/app/activiti/selectTodo", params, config);
};

export const getTaskCount = (params: any, config?: RequestConfig): Promise<ApiResponse<ITaskCount>> => {
  return request.get("/app/activiti/taskCount", params, config);
}

// 批量审批接口
export const doTask = (
  action: string,
  taskIds: string[],
  options?: { returnTarget?: string },
  config?: RequestConfig
): Promise<ApiResponse<any>> => {
  const data: any = { taskIds }
  if (options?.returnTarget) data.returnTarget = options.returnTarget
  return request.post(`/app/activiti/doTask/${action}`, data, config);
}

// 保存并获取节点信息
export const saveAndGetData = (data: any[], config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/save', data, config);
}

// D&C Pending 接口
export const pendingTask = (data: { doorCode: string; taskId: string }[], config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/status-change/pending', data, config);
}

// D&C Drop 接口
export const dropTask = (data: string[], config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/drop', data, config);
}
